import { action, Action } from 'easy-peasy';
import { TextMarkStruct } from '@meitu/saas-editor-core/es/layers/text-layer/types/text-mark';

export interface ITextArtConfig {
    useBlackText?: number;
}

export interface ITextMarkModel {
    textLayerId: string;
    setTextLayerId: Action<ITextMarkModel, string>;
    markConfig: TextMarkStruct | null;
    setMarkConfig: Action<ITextMarkModel, TextMarkStruct | null>;
    textArtConfig: ITextArtConfig | null;
    setTextArtConfig: Action<ITextMarkModel, ITextArtConfig | null>;
}

export const textMarkModel: ITextMarkModel = {
    textLayerId: '',
    setTextLayerId: action((state, payload) => {
        state.textLayerId = payload;
    }),
    markConfig: null,
    setMarkConfig: action((state, payload) => {
        state.markConfig = payload;
    }),
    textArtConfig: null,
    setTextArtConfig: action((state, payload) => {
        state.textArtConfig = payload;
    }),
};
